// extracted by mini-css-extract-plugin
export var aircallIframe = "_dv-3";
export var fabContainer = "_dv-5";
export var fabRinging = "_dv-6";
export var loadingOverlay = "_dv-4";
export var pulse = "_dv-7";
export var widgetContent = "_dv-2";
export var widgetPanel = "_dv-0";
export var widgetPanelExpanded = "_dv-1";